import React, { useState } from 'react'

import { ConditionalSlider } from './ConditionalSlider'
import { joinClassNames } from '../../utils'
import { Slide } from './Slide'

const Carousel = ({ slides, loading, overlay: Overlay, className, onSlideChange }) => {
  const [slideIndex, setSlideIndex] = useState()
  const handleSlideChange = (idx) => {
    onSlideChange(idx)
    setSlideIndex(idx)
  }

  return (
    <div className={ joinClassNames('carousel', className) }>
      { loading &&
        <div className="carousel--loader">loading...</div>
      }

      { !loading && slides &&
          <ConditionalSlider
            className="carousel--slider"
            onSlideChange={ handleSlideChange }
          >
            { slides.map(
              ({ slug, fileName, title, filePath, category }, index) => (
                <Slide
                  className="carousel--slide"
                  filename={ fileName }
                  filepath={ filePath }
                  key={`${slug}__${index}`}
                  slug={ slug }
                />
              )
            )}
          </ConditionalSlider>
        }

        { !loading && Overlay && slides &&
          <Overlay
            className="carousel--caption"
            data={ slides[slideIndex || 0] }
          />
        }
    </div>
  )
}

export default Carousel